/* tslint:disable */
/* eslint-disable */
/**
 * LMS API
 * This is LMS API Documentation.
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * get csv admin study reports request
 * @export
 * @interface GetCsvAdminStudyReportsRequest
 */
export interface GetCsvAdminStudyReportsRequest {
    /**
     * 
     * @type {number}
     * @memberof GetCsvAdminStudyReportsRequest
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof GetCsvAdminStudyReportsRequest
     */
    userID?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCsvAdminStudyReportsRequest
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCsvAdminStudyReportsRequest
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCsvAdminStudyReportsRequest
     */
    status?: GetCsvAdminStudyReportsRequestStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum GetCsvAdminStudyReportsRequestStatusEnum {
    Valid = 'VALID',
    Invalid = 'INVALID'
}



